import { UserType } from "../@client/Theasoft_DataTypes_Enums"
import {
  RemoteMultiSelect,
  RemoteMultiSelectProps,
} from "./remote-multi-select"
import { SelectEntity, SelectEntityProps } from "./entity-select"
import {
  SimpleUserWithPersonAndEmailInfo,
  UserTypeFilter,
} from "../@client/Theasoft_ApiServer_Users"

type UserComboboxItemOption = {
  value: string
  label: string
  secondaryLabel?: string | undefined
  hasPrimaryEmail: boolean
  userType: UserType
}
export type UserComboboxItem = {
  option: UserComboboxItemOption
}

const getUserUrl = "/api/User/GetSimpleUsersWithPersonAndEmailInfoForAbsence"
type GetUserUrl = typeof getUserUrl

type UserSelectProps = Omit<
  RemoteMultiSelectProps<GetUserUrl, number>,
  "url" | "map" | "toValue" | "fromValue" | "renderOption"
> & {
  excludeUserIds?: number[]
  UserType?: UserTypeFilter
  renderOption?: (item: UserComboboxItem) => React.ReactNode
}
export function AbsenceUserWithEmailInfoSelect({
  UserType,
  renderOption,
  ...props
}: UserSelectProps) {
  return (
    <RemoteMultiSelect<GetUserUrl, number>
      label="User"
      url={getUserUrl}
      toRequest={(search) => ({
        searchString: search,
        userTypeFilter: UserType ?? "UsersAndGroups",
        filterInactive: true,
        pageParam: 0,
        pageSize: 100,
        includeUserIds: props.value ?? [],
        excludeUserIds: props.excludeUserIds ?? [],
        includeTotalCount: false,
      })}
      map={(value) => ({
        value: value.userId.toString(),
        label: value.userName,
        userType: value.userType,
        hasPrimaryEmail: value.hasEmail,
      })}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      renderOption={renderOption ? (v) => renderOption(v as any) : undefined}
      searchable
      toValue={(value) => parseInt(value)}
      fromValue={(value) => value.toString()}
      {...props}
    />
  )
}

export interface UserSingleSelectProps extends Omit<
  SelectEntityProps<GetUserUrl>,
  "getId" | "url" | "getLabel" | "renderOption"
> {
  excludeUserIds?: number[]
  userTypeFilter?: UserTypeFilter
  getLabel?: (user: SimpleUserWithPersonAndEmailInfo) => string
}

export function UserSingleSelect({
  excludeUserIds,
  userTypeFilter,
  getLabel,
  ...props
}: UserSingleSelectProps) {
  return (
    <SelectEntity
      url={getUserUrl}
      toRequest={(search) => ({
        searchString: search,
        userTypeFilter: userTypeFilter ?? "Users",
        filterInactive: true,
        pageParam: 0,
        pageSize: 100,
        includeUserIds: props.value ? [props.value] : [],
        excludeUserIds: excludeUserIds ?? [],
        includeTotalCount: false
      })}
      getLabel={getLabel ? getLabel : (v) => v.userName}
      getId={(v) => v.userId}
      {...props}
    />
  )
}
